import React from 'react';

import Layout from '../../components/Layout';
import PartialsHeader from '../../components/Partials/PartialsHeader';
import ServicesHeading from '../../components/SoftwareServices/ServicesHeading';
import Softwares from '../../components/SoftwareServices/Softwares';
import MVPbox from '../../components/SoftwareServices/MVPBox';
import HomeTestimonials from '../../components/Home/HomeTestimonials';
import ResultsCardSwiperSection from '../../components/ResultsCardSwiperSection';
import LandingPageInfoBox from '../../components/LandingPages/LandingPageInfoBox';
import imagesLandingPages from '../../components/imagesLandingPages';
import imagesPillarPages from '../../components/imagesPillarPages';
import HomeKnowledge from '../../components/Home/HomeKnowledge';
import Banner from '../../components/service/Products/productsPartials/DevOpsBanner';
import SingleBox from '../../components/Careers/careersPartials/SingleBox';
import TelecommunicationSection from '../../components/SoftwareServices/TelecommunicationSection';
import SectionBoxes from '../../components/CryptoPythonLandingPages/LandingSectionBoxes';
import DedicList from '../../components/SoftwareServices/DedicList';

import StepFirst from '../../components/SoftwareServices/StepFirst';
import StepMiddle from '../../components/SoftwareServices/StepMiddle';
import StepLast from '../../components/SoftwareServices/StepLast';

import content from '../../components/SoftwareServices/content-mvp-development';

export default ({ location }) => (
  <Layout
    title="MVP - Minimum viable product development services | Ulam Labs"
    description="Build MVP to hit the market fast. Get an experienced technology partner to guide you through the development process."
    urlCanonical={location.href}
  >
    <PartialsHeader>
      <div className="container">
        <div className="content">
          <div className="body">
            <h1 className="title">MVP development services</h1>
          </div>
        </div>
      </div>
    </PartialsHeader>
    <ServicesHeading headingText={content.headingText} />
    <div className="telecommunication text-format  mt-1 mvp-tele">
      <Softwares withText content={content.softwaresText} />
    </div>
    <SectionBoxes staticContent={content.sectionBoxes} versionPillar mvp />
    <DedicList staticContent={content.dedicData} />
    <MVPbox customColumnsText={content.mvpBox} />
    <div className="version-pillar" style={{ background: '#eaebf1' }}>
      <HomeTestimonials
        customTitle="What our clients say about our MVP development services?"
        customSubtitle="Founders, CEOs and top managers from all over the world value our services especially for smooth communication, expertise and timely product delivery. Read customer opinions which prove that we are a perfect technology partner for you as well."
        useSpecificTestimonial={[
          'Ali Bahsoun',
          'Hamlet Batista',
          'Steve Swain',
          'William Yin'
        ]}
      />
    </div>
    <div className="container">
      <div className="row">
        <div className="col subtitle without bigger my-5">
          <h2>MVPs we have delivered</h2>
          <h4 className="extra">
            We have closely worked with these startups from various industries
            and have helped them build their MVP. We are proud to see them
            growing!
          </h4>
        </div>
      </div>
    </div>
    <div className="js-swiper">
      <ResultsCardSwiperSection
        title="MVPs we have successfully delivered"
        buttonsAround={false}
        className="basis-slider"
        useSpecificCases={[
          'event-platform-medtech',
          'software-for-construction-sector',
          'cryptocurrency-lending-platform',
          'personalized-fragrance-platform'
        ]}
        onlySlider
        withSubtitle
      />
    </div>
    <div className="container">
      <div className="row">
        <div className="col subtitle without bigger my-5">
          <h2>How we build MVP for startups and SMEs</h2>
          <h4 className="extra">
            Across many years of building digital products for our customers, we
            have implemented a proven method that helps to build quality,
            dynamic and scalable products within the given timeframe.
          </h4>
        </div>
      </div>
    </div>
    <div className="vertical-steps big-padding">
      <StepFirst staticContent={content.steps.stepOne} />
      <StepMiddle bg staticContent={content.steps.stepTwo} />
      <StepMiddle img staticContent={content.steps.stepThree} />
      <StepMiddle bg staticContent={content.steps.stepFour} />
      <StepMiddle staticContent={content.steps.stepFive} />
      <StepLast bg withoutCoreImg staticContent={content.steps.stepSix} />
    </div>
    <div className="container mvp-banner">
      <Banner
        customTitle="Let's start building MVP of your product"
        version="servicesPage"
        customBtnText="Work with us"
      />
    </div>
    <div className="mvp-tele">
      <TelecommunicationSection
        telecomSectionData={content.telecomSectionData}
      />
    </div>
    <div className="container mt-5">
      <h2 className="subtitle bigger without">Why work with Ulam Labs?</h2>
      <div className="work-with d-flex flex-column flex-md-row justify-content-between">
        <LandingPageInfoBox
          icon={imagesLandingPages.pythonSVG}
          title="Python is our core business"
          description="Ulam Labs has been developing services in Python - one of the best programming languages suitable for fast MVP development."
        />
        <LandingPageInfoBox
          icon={imagesPillarPages.consultingSVG}
          title="Experienced engineers"
          description="Work daily with skilled and experienced IT professionals building cutting-edge software products."
        />
        <LandingPageInfoBox
          icon={imagesLandingPages.teamextensionSVG}
          title="Flexible collaboration"
          description="Get a dedicated team of developers full-time, part-time, or hourly. Scale up your team according to your needs."
        />
      </div>
      <div className="work-with d-flex flex-column flex-md-row justify-content-between">
        <LandingPageInfoBox
          icon={imagesPillarPages.scrumSVG}
          title="Scrum and agile team"
          description="Scrum means that your product will be delivered fast and efficiently."
        />
        <LandingPageInfoBox
          icon={imagesLandingPages.icon4SVG}
          title="Complementary services"
          description="We have everything you need for a long-term, end-to-end tech partnership."
        />
        <LandingPageInfoBox
          icon={imagesLandingPages.ourroleSVG}
          title="Client's trust"
          description="More than 90% of our customers come back with their new projects and recommend our services."
        />
      </div>
    </div>
    <div className="knowledge-services padd-t-sm padd-b-sm">
      <HomeKnowledge
        useSpecificPostsByUrl={[
          '/blog/why-build-minimum-viable-product/',
          '/blog/why-is-python-so-popular/',
          '/blog/poc-prototype-and-mvp-differences/'
        ]}
        customTitle="Read about minimum viable product development on our blog"
        customSubtitle="Our team of developers takes an active part in creating educational and valuable content for our clients who are thinking about building their digital products. Read our blog to understand the terms, technology and processes involved in a minimum viable product creation."
        versionPillar
        setPythonMiddle
      />
    </div>
    <div className="container my-4 my-md-0 services-banner-top">
      <Banner
        customTitle="Looking for MVP development company for your product?"
        version="servicesPage"
      />
    </div>
    <div className="version-pillar pb-5 container padd-t">
      <div className="info-box">
        <div>
          <h3 className="subtitle without bigger">
            What other services do we offer?
          </h3>
          <div className="row">
            <SingleBox
              image={imagesPillarPages.chainSVG}
              heading="Blockchain development"
              url="/software-services/blockchain-development/"
            />
            <SingleBox
              image={imagesLandingPages.pythonSVG}
              heading="Python development"
              url="/software-services/python-development/"
            />
            <SingleBox
              image={imagesPillarPages.logoJS}
              heading="JavaScript development"
              url="/software-services/javascript-development/"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
);
